<template>
  <li class="document-list-item-wrapper">
    <slot />
  </li>
</template>

<style lang="less" scoped>
.document-list-item-wrapper {
  min-height: 64px;
  max-height: 64px;
  height: 100%;
  background-color: @bg-default;

  &:hover {
    background-color: @bg-dark;
    cursor: pointer;
  }
}
</style>
